import BaseApi from '../BaseApi';
import { NotificationsApiConverter } from './NotificationsApiConverter';

class NotificationsApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/mini_admin`;
    this.converter = new NotificationsApiConverter();
  }

  getNotifications = (lang) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/notifications/list`,
      {
        lang,
        limit: 50,
      },
      null,
      this.converter.convertNotifications,
    );

  getNotificationsCount = () =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/notifications/count`,
      null,
      null,
      this.converter.convertNotificationsCount,
    );

  setNotificationRead = (ids) =>
    this.sendQuery(
      this.queryTypes.PUT,
      `${this.baseUrl}/notifications/read`,
      {
        ids,
      },
    );

  setNotificationClosed = (id) =>
    this.sendQuery(
      this.queryTypes.PUT,
      `${this.baseUrl}/notifications/close`,
      {
        id,
      },
    );

  setAllNotificationsClosed = () =>
    this.sendQuery(
      this.queryTypes.PUT,
      `${this.baseUrl}/notifications/close/all`,
    );
}

export default NotificationsApi;
